function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "surface1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.875,10.75c-8.84221,0 -16.125,7.28279 -16.125,16.125v107.5c0,8.84221 7.28279,16.125 16.125,16.125h107.5c8.84221,0 16.125,-7.28279 16.125,-16.125v-107.5c0,-8.84221 -7.28279,-16.125 -16.125,-16.125zM26.875,21.5h107.5c3.02579,0 5.375,2.34921 5.375,5.375v107.5c0,3.02579 -2.34921,5.375 -5.375,5.375h-107.5c-3.02579,0 -5.375,-2.34921 -5.375,-5.375v-107.5c0,-3.02579 2.34921,-5.375 5.375,-5.375zM53.75,43v75.25h10.75v-21.5h26.875c14.78109,0 26.875,-12.09391 26.875,-26.875c0,-14.78109 -12.09391,-26.875 -26.875,-26.875h-26.875h-5.375zM64.5,53.75h26.875c8.97641,0 16.125,7.14859 16.125,16.125c0,8.97641 -7.14859,16.125 -16.125,16.125h-26.875z"
}));

var SvgResourceServiceParking = function SvgResourceServiceParking(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 172 172",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResourceServiceParking, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/resource-service-parking.399f9694.svg";
export { ForwardRef as ReactComponent };